export default "__VITE_ASSET__dd942c8b__"